import axios from "axios";

const API = "/api";

export async function buscarOfertas({ clienteId, anonId, modulo = "Cardapio" }) {
  const params = clienteId ? { cliente_id: clienteId, modulo } : { anon_id: anonId, modulo };
  const { data } = await axios.get(`${API}/public/ofertas-do-dia`, { params, timeout: 8000 });
  return data;
}

// sendBeacon sobrevive ao fechamento da aba; fetch keepalive é o plano B.
export function enviarTelemetria(payload) {
  const url = `${API}/public/ofertas-do-dia/telemetria`;
  const corpo = JSON.stringify(payload);
  try {
    if (navigator.sendBeacon) {
      const ok = navigator.sendBeacon(url, new Blob([corpo], { type: "application/json" }));
      if (ok) return;
    }
  } catch { /* cai no fetch */ }
  try {
    fetch(url, { method: "POST", body: corpo, headers: { "Content-Type": "application/json" }, keepalive: true });
  } catch { /* medição nunca atrapalha o cardápio */ }
}
